// src/features/tidsregistering/hooks/useTidsregistreringStatistics.js
import { useState, useCallback, useRef } from 'react';
import { tidsregistreringStatisticsAPI } from '../services/statistics';
import { useApi } from '../../../hooks/api/useApi';

export function useTidsregistreringStatistics() {
  const [statistics, setStatistics] = useState(null);
  const { loading, error, execute } = useApi();
  const requestIdRef = useRef(0);

  const fetchAnalyse = useCallback(async (startDate, endDate) => {
    const requestId = ++requestIdRef.current;
    const result = await execute(() => tidsregistreringStatisticsAPI.getAnalyse(startDate, endDate));
    // Ignore responses superseded by a newer fetchAnalyse call so a slow
    // request can't overwrite fresher data that already resolved.
    if (result.success && requestId === requestIdRef.current) setStatistics(result.data?.data ?? null);
    return result;
  }, [execute]);

  return { statistics, loading, error, fetchAnalyse };
}
